import { render, staticRenderFns } from "./LvImgList.vue?vue&type=template&id=66f37d06"
import script from "./LvImgList.vue?vue&type=script&lang=js"
export * from "./LvImgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports